import { BoxProps } from '@rover/kibble/core';

export enum CalloutSlugs {
  backgroundCheck = 'search-badge-callout',
  petInfo = 'pet-info-callout',
  emptyResults = 'empty-results-callout',
}

export type EmptyResultsCallout = {
  position: number;
  data: {
    title: string;
    subtitle?: string;
  };
  slug: CalloutSlugs.emptyResults;
};

export type BackgroundCheckCalloutData = {
  title: string;
  badgeSlug: string;
  imageUrl: string;
  backgroundColor: string;
  highlightedTitleText: string;
  dialogData: {
    title: string;
    ctaText: string;
    items: Array<{
      title: string;
      description: string;
      imageUrl: string;
      ctaText: string;
      action: string;
    }>;
  };
};

export type BackgroundCheckCallout = {
  position: number;
  slug: CalloutSlugs.backgroundCheck;
  data: BackgroundCheckCalloutData;
};

export type PetInfoAnswer = {
  id: string;
  label: string;
  value: string;
};

export type PetInfoQuestion = {
  id: string;
  question: string;
  answers: PetInfoAnswer[];
  backgroundColor: NonNullable<BoxProps['background']>;
  image: string;
  imageDescription: string;
};

export type PetInfoQuestionCallout = {
  data: {
    questions: PetInfoQuestion[];
  };
  slug: CalloutSlugs.petInfo;
  position: number;
};

export type Callout = EmptyResultsCallout | BackgroundCheckCallout | PetInfoQuestionCallout;
